import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { TOKEN_KEY } from "../../../Utils/Constants";
import { baseUrl } from "../../../shared/baseUrl";
import { createNotification } from "../../Common/CreateNotification";
import { changeUser } from "../../../Redux/reducers/userSlice";
import { useParams } from "react-router-dom";

const LoginAs = () => {

    const { token } = useParams()

    const dispatch = useDispatch();
    const [isTokenError, setIsTokenError] = useState(false);

    useEffect(() => {
        getUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getUser = async () => {
        await fetch(baseUrl + 'get-user-details', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        })
            .then((res) => res.json())
            .then((res) => {

                if (res.success) {
                    console.log(res.user);
                    res.user['token'] = token;
                    localStorage.setItem(TOKEN_KEY, JSON.stringify(res.user));
                    dispatch(changeUser(res.user));
                    window.location.href = '/';

                }
                else {
                    createNotification('error', res.message);
                    setIsTokenError(true);
                }
            })
            .catch((e) => {
                createNotification('error', e.message);
                setIsTokenError(true);
            })

    }


    return (
        <div style={{ height: "90vh" }} className='d-flex flex-wrap w-100 justify-content-center align-items-center'>
            <div className='text-center small'>
                <img alt="logo" style={{ objectFit: "contain", height: "20vh", width: "20vh" }} src="/assets/images/logo.png" />
                <h3>Validating User . . .</h3>
                <h5 className="text-danger">{isTokenError ? "Invalid Token" : ""}</h5>
            </div>
        </div>
    );
}

export default LoginAs;